import type { IconProps } from "types";

const Beneficiaries = ({ width = "20", height = "20" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_278_2689)">
      <path
        d="M5.83333 14.1667C6.98393 14.1667 7.91667 13.2339 7.91667 12.0833C7.91667 10.9327 6.98393 10 5.83333 10C4.68274 10 3.75 10.9327 3.75 12.0833C3.75 13.2339 4.68274 14.1667 5.83333 14.1667Z"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 14.1667C15.3173 14.1667 16.25 13.2339 16.25 12.0833C16.25 10.9327 15.3173 10 14.1667 10C13.0161 10 12.0833 10.9327 12.0833 12.0833C12.0833 13.2339 13.0161 14.1667 14.1667 14.1667Z"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5.83335C11.1506 5.83335 12.0833 4.90061 12.0833 3.75002C12.0833 2.59943 11.1506 1.66669 10 1.66669C8.84941 1.66669 7.91667 2.59943 7.91667 3.75002C7.91667 4.90061 8.84941 5.83335 10 5.83335Z"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.3334C10 16.0322 8.1345 14.1667 5.83334 14.1667C3.53215 14.1667 1.66667 16.0322 1.66667 18.3334"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 18.3334C18.3333 16.0322 16.4678 14.1667 14.1667 14.1667C11.8655 14.1667 10 16.0322 10 18.3334"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 9.99998C14.1667 7.69881 12.3012 5.83331 9.99999 5.83331C7.69883 5.83331 5.83333 7.69881 5.83333 9.99998"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_278_2689">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Beneficiaries;
